$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('common.backend', ['angular-phoenix']).provider('Config', function() {
    var $__0 = this;
    this.BASE = 'https://euschoolfruit.apps.miraclethings.nl/';
    this.USER_ID = localStorage.userId || (function() {
      var length = 40;
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      localStorage.userId = text;
      return text;
    })();
    this.$get = (function() {
      return $__0;
    });
  }).service('Backend', function($http, Config, Phoenix) {
    var getSecret = (function(code) {
      return localStorage['secrets.' + code] || false;
    });
    return {
      create: (function() {
        return $http.post(Config.BASE + 'quiz').then((function(r) {
          localStorage['secrets.' + r.data.code] = r.data.secret;
          return r.data.code;
        }));
      }),
      joinChannel: (function(name, code) {
        var secret = getSecret(code);
        return Phoenix.channel((name + ":" + code), {secret: secret}).join().promise;
      })
    };
  }).config(function(PhoenixProvider, ConfigProvider) {
    PhoenixProvider.setUrl(ConfigProvider.BASE.replace(/^http/, 'ws') + 'socket');
    PhoenixProvider.defaults = {user_id: ConfigProvider.USER_ID};
  }).service('loadGameConfig', (function($http, $q) {
    var config = false;
    return (function() {
      if (config !== false) {
        return $q.when(config);
      }
      return $http.get('config.json').then((function(r) {
        config = r.data;
        return config;
      }));
    });
  })).service('ClassroomSettings', function() {
    var state = JSON.parse(localStorage.state || '{}');
    var set = (function(data) {
      angular.merge(state, data);
      localStorage.state = JSON.stringify(state);
    });
    return {
      set: set,
      get: (function() {
        return angular.extend({}, state);
      })
    };
  }).service('resolveChannel', (function($stateParams, $state, $rootScope, $q, Backend, ClassroomSettings, AudioManager) {
    return (function(name) {
      var classroom = ClassroomSettings.get().code;
      if (typeof classroom == 'undefined' || classroom == '0') {
        return $q.when(false);
      }
      return Backend.joinChannel('organizer', classroom).then((function(channel) {
        channel.on($rootScope, 'game_status', (function(p) {
          var old_player_count = (typeof $rootScope.game_status != 'undefined' ? $rootScope.game_status.player_count : 0);
          if (p.player_count > old_player_count) {
            AudioManager.play('ping');
          }
          $rootScope.game_status = p;
        }));
        return channel;
      })).catch((function(e) {
        ClassroomSettings.set({
          interactive: false,
          code: 0
        });
        console.log('someting went wrong');
      }));
    });
  })).service('TestScore', function() {
    var introScore = {};
    return {
      score: (function() {
        var total_score = 0;
        for (var slideID in introScore) {
          total_score += introScore[slideID];
        }
        return total_score;
      }),
      add: (function(slide, score) {
        introScore[slide] = score;
        return introScore;
      }),
      reset: (function() {
        introScore = {};
      })
    };
  }).service('AudioManager', function($http, $rootScope) {
    var samples = {};
    var muted = false;
    var load = (function() {
      var base_url = (typeof localized !== 'undefined' ? localized.assets : '');
      $http.get(base_url + 'sounds/samples.json').then((function(r) {
        r.data.map((function(sampleName) {
          var audio = new Audio();
          audio.src = base_url + 'sounds/' + sampleName + '.mp3';
          audio.onended = function() {
            audio.currentTime = 0;
          };
          samples[sampleName] = audio;
        }));
      }));
    });
    $rootScope.$on('$stateChangeSuccess', (function() {
      for (var k in samples) {
        try {
          samples[k].pause();
        } catch (e) {}
      }
    }));
    return {
      play: (function(name) {
        if (!samples[name])
          return;
        samples[name].volume = 0.2;
        samples[name].play();
        samples[name].onended = function() {
          samples[name].pause();
        };
      }),
      voiceover: (function(name) {
        if (!samples[name])
          return;
        return samples[name];
      }),
      load: load,
      stop: (function(name) {
        samples[name].pause();
      }),
      isMuted: (function() {
        return muted;
      }),
      toggleMuted: (function() {
        muted = !muted;
        for (var sample in samples) {
          samples[sample].muted = muted;
        }
      })
    };
  }).service('VoiceOver', function($rootScope) {
    var voiceover = new Audio();
    return {
      play: (function(url, cb) {
        voiceover.src = url;
        voiceover.play();
        voiceover.onended = cb;
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
          voiceover.pause();
        });
      }),
      stop: (function() {
        voiceover.pause();
      })
    };
  });
  ;
  return {};
});

